<!-- 组件说明 -->
<template>
  <div class="con" onselectstart ='return false'>
    <div class="listHeader">
      <div class="l">
        <span>显示方式</span>
        <div class="listBtn">
          <div
            class="list c-pointer"
            :class="{ active3: type == 1 }"
            @click="showList"
          >
            <img :src="require('@/assets/images/icon_c1.png')" v-if="type == 2" alt="" />
            <img :src="require('@/assets/images/icon_c2.png')" v-else alt="" />
            <span>列表</span>
          </div>
          <div
            class="table c-pointer"
            :class="{ active3: type == 2 }"
            @click="showTable"
          >
            <img :src="require('@/assets/images/icon_d1.png')" v-if="type == 1" alt="" />
            <img :src="require('@/assets/images/icon_d2.png')" v-else alt="" />
            <span>表格</span>
          </div>
        </div>
      </div>
      <div class="m" v-if="total">
        <span class="c-pointer" @click="clear">默认排序</span>
        <!-- <div class="sell c-pointer" @click="handleSort(index)"  v-for="(item,index) in sortList" :key="index">
          <i :class="{'active2': activeIndex == index }" >{{item.name}}
            <img :src="require('@/assets/images/icon_f01.png')" alt="" v-if="activeIndex !== index" />
            <img :src="require('@/assets/images/icon_f02.png')" alt="" v-if="activeIndex == index&&orderType=='DESC'"/>
            <img :src="require('@/assets/images/icon_f03.png')" alt="" v-if="activeIndex == index&&orderType=='ASC'"/>

          </i>
        </div> -->
        <!-- <div class="price c-pointer" @click="handleSort(2)">
          <i :class="{ active2: sortPrice }"
            >价格
            <img src="@/assets/images/icon_f01.png" alt="" v-if="!sortPrice" />
            <img src="@/assets/images/icon_f02.png" alt="" v-else
          /></i>
        </div> -->
        <!-- <div class="stock"><el-checkbox  v-model="stockchecked"  @change='changeCheck'></el-checkbox> <i>有货</i></div> -->
      </div>
      <div class="r" v-if="total">
        <p>共 <span>{{total}}</span> 个商品</p>&nbsp;
        <span><i>{{pageNumber}} </i> / {{Math.ceil(total/ pageSize)}}</span>
        <div class="pageBtn">
          <div class="pre c-pointer" @click="prePage"><i class="el-icon-arrow-left"></i></div>
          <div class="next c-pointer" @click="nextPage"><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      type: 1, //1列表  2表格
      sortList:[
        {name:'销量'},
         {name:'价格'}
      ],
      activeIndex:null,
      stockchecked:false,
      orderType:'ASC',//ASC,DESC
    };
  },
  props:['total','pageNumber','pageSize'],
  computed: {},
  methods: {
    showList() {
      this.type = 1;
      this.$emit("changeType", this.type);
    },
    showTable() {
      this.type = 2;
      this.$emit("changeType", this.type);
    },
    prePage(){
      this.$emit('changenum',-1)
    },
    nextPage(){
       this.$emit('changenum',1)

    },
    changeCheck(){
     this.$emit('changeCheckbox',this.stockchecked)

    },
    handleSort(i){
      if(this.activeIndex == i){
        if(this.orderType == 'DESC'){
          this.orderType = 'ASC'
        }else{
          this.orderType = 'DESC'
        }
     }else{
       this.orderType = 'ASC'
     }
     this.activeIndex = i;
     
      if(i == 0){
         this.$emit("changeSort", {orderProperties:'sales',orderType:this.orderType});
      }
      else{
          this.$emit("changeSort",{orderProperties:'price',orderType:this.orderType});
      }
     console.log(this.orderType)
    },
    clear(){
      this.activeIndex = null
       this.$emit("changeSort", '');
    }

  },
};
</script>

<style lang='scss' scoped>
.listHeader {
  position: relative;
  width: 100%;
  height: 40px;
  border: 1px solid #f0f0f0;
  background-color: #ffffff;
}
.listHeader,
.l,
.listBtn,
.r,
.pageBtn,
.m {
  display: flex;
  align-items: center;
  color: #666666;
  font-size: 13px;
}
.l {
  border-right: 1px solid #eeeeee;
  > span {
    display: block;
    margin: 0 15px 0 22px;
  }
  .listBtn {
    border-radius: 3px;
    margin-right: 30px;
    .list,
    .table {
      width: 72px;
      height: 26px;
      @include font(13px, #666666, center, 400, 26px);
      img {
        margin-right: 5px;
      }
    }
    .list {
      border: 1px solid #eeeeee;
      border-radius: 3px 0 0 3px;
  
    }
    .table {
      border: 1px solid #eeeeee;
      border-radius: 0 3px 3px 0;
    img {
        margin-bottom: -1px;
      }

    }
  }
}
.active,
.active2 {
  color: #f43737 !important;
}
.active3 {
  color: #f43737 !important;
  border-color: #f43737 !important;
}
.m {
  text-align: center;
  line-height: 40px;
  span {
    display: inline-block;
    width: 120px;
    border-right: 1px solid #eeeeee;
  }
  div {
    width: 98px;
    border-right: 1px solid #eeeeee;
  }
  .sell,
  .price {
    img {
      margin-left: 8px;
    }
  }
}
.active2 {
  border-bottom: 2px solid #f43737;
  padding-bottom: 9px;
}
.r {
  position: absolute;
  right: 20px;
  i {
    color: #fa4b4b;
  }
  .pre,
  .next {
    width: 20px;
    height: 20px;
    text-align: center;
    @include flex-c;
    border: 1px solid #eeeeee;
    i{
      color: #666666;
    }
  }
  .pre {
    margin: 0 10px 0 20px;
  }
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #fa4b4b;
      border-color:#fa4b4b
}
>>>.el-checkbox__inner:hover{
   border-color:#eeeeee
}
>>>.el-checkbox__input.is-focus .el-checkbox__inner{
   border-color:#eeeeee
}
</style>


// WEBPACK FOOTER //
// src/pages/main/search/components/goods-header.vue